import * as React from "react";
import { Navbar } from "react-bootstrap";
import DataProvider from "../../dataprovider/DataProvider";

import { useIsAuthenticated } from "@azure/msal-react";
import { MicrosoftComponent } from "./MicrosoftComponent";
import "bootstrap/dist/css/bootstrap.min.css";

import "./sLoginComponent.scss";
import GoogleLoginComponent from "./GoogleComponent";
import { ICustomAuthComponent as CustomAuthComponent } from "./CustomAuthComponent";
import { mergeStyles } from "@uifabric/merge-styles";
import { Callout, Dialog, DialogType, IButton, Icon, IconButton, IRefObject, Target } from "office-ui-fabric-react";
import { Redirect } from "react-router";

require("./LoginComponent.css");

export enum AccountType {
	Microsoft = "Microsoft",
	Google = "Google",
	Custom = "Custom",
}

export interface ILoginComponentProps {
	setAuthStatus: (signedIn: boolean, user: IUserAccount) => Promise<void>;
	currentUser: IAuthenticatedUser;
}

export interface ILoginComponentState {
	loggedInWithGoogle: boolean;
	loggedInWithMicrosoft: boolean;
	loggedInWithCustomAccount: boolean;
	currentUser: IAuthenticatedUser;

	isCalloutOpen: boolean;
	isLoggedIn: boolean;
	isCustomPanelOpen: boolean;

	error_provider: string;
	isErrorOpen: boolean;
}

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
	graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

export class LoginComponent extends React.Component<ILoginComponentProps, ILoginComponentState> {
	private dataProvider = new DataProvider();
	private refPersonIcon: React.RefObject<Element> = null;

	constructor(props: ILoginComponentProps) {
		super(props);

		this.state = {
			isLoggedIn: Boolean(props.currentUser),
			currentUser: props.currentUser,
			loggedInWithGoogle: props.currentUser && props.currentUser.accountType == AccountType.Google,
			loggedInWithMicrosoft: props.currentUser && props.currentUser.accountType == AccountType.Microsoft,
			loggedInWithCustomAccount: props.currentUser && props.currentUser.accountType == AccountType.Custom,

			isCalloutOpen: false,

			isCustomPanelOpen: false,

			error_provider: null,
			isErrorOpen: false,
		};

		this.refPersonIcon = React.createRef<Element>();
	}
	public componentDidMount() {}

	public ensureSPUser = (userInformation: IUserAccount, token: string, isRSMToken: boolean): Promise<IAuthenticatedUser> => {
		return this.dataProvider
			.ensureExternalUserAccount(userInformation, token, isRSMToken)
			.then((result: IAuthenticatedUser) => {
				console.log(result);
				window.sessionStorage.authToken = JSON.stringify(result.bearerToken);
				window.sessionStorage.stlUser = JSON.stringify(result);

				return result;
			})
			.catch((err) => {
				console.dir(err);
				window.sessionStorage.removeItem("authToken");
				window.sessionStorage.removeItem("stlUser");
				return Promise.reject(err);
			});
	};

	private showAuthenticationError = (provider: string): void => {
		this.setState({
			error_provider: provider,
			isErrorOpen: true,
		});
	};

	public componentWillReceiveProps(newProps: ILoginComponentProps) {
		if (this.state.currentUser != newProps.currentUser) {
			this.setState({
				isLoggedIn: Boolean(newProps.currentUser),
				currentUser: newProps.currentUser,
				loggedInWithGoogle: newProps.currentUser && newProps.currentUser.accountType == AccountType.Google,
				loggedInWithMicrosoft: newProps.currentUser && newProps.currentUser.accountType == AccountType.Microsoft,
				loggedInWithCustomAccount: newProps.currentUser && newProps.currentUser.accountType == AccountType.Custom,
			});
		}
	}

	public render(): React.ReactElement<ILoginComponentProps> {
		// hide the whole login component if the user is on the pages: 'confirmation', 'resetPW'
		let curUrl = window.location.href.toLowerCase();
		let hideLoginComponent = curUrl.includes("confirm") || curUrl.includes("resetpw") || curUrl.includes("consent") || curUrl.includes("submitagreement");
		console.log(hideLoginComponent);
		let signedIn = this.state.loggedInWithCustomAccount || this.state.loggedInWithGoogle || this.state.loggedInWithMicrosoft;

		// Login component AND person symbol should be displayed on the right screen border
		let signedInStyles = mergeStyles(
			hideLoginComponent
				? [
						{ display: "none" },
						{
							position: "absolute",
							right: "20px",
						},
				  ]
				: [
						{ height: "calc(100% - 100px)" },
						{
							position: "absolute",
							right: "20px",
						},
				  ]
		);

		const { loggedInWithCustomAccount, loggedInWithGoogle, loggedInWithMicrosoft, isCustomPanelOpen } = this.state;

		return (
			<div className={signedInStyles}>
				{!(this.state.loggedInWithCustomAccount || this.state.loggedInWithGoogle || this.state.loggedInWithMicrosoft) && (
					<div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
						<div id="gSignInWrapper">
							{!this.state.loggedInWithMicrosoft && !this.state.loggedInWithCustomAccount && !isCustomPanelOpen ? (
								<GoogleLoginComponent
									currentUser={this.state.currentUser}
									callback={this.ensureSPUser}
									showError={this.showAuthenticationError}
									setAuthStatus={(loggedIn: boolean, user: IAuthenticatedUser) => {
										//console.log("GoogleLogin: ", loggedIn);
										//console.log("Google account", user);
										return new Promise((resolve, reject) => {
											this.setState(
												(prevState) => {
													let isLoggedIn = prevState.loggedInWithCustomAccount || loggedIn || prevState.loggedInWithMicrosoft;
													return {
														loggedInWithGoogle: loggedIn,
														loggedInWithCustomAccount: false,
														loggedInWithMicrosoft: false,
														isLoggedIn: isLoggedIn,
														currentUser: user,
														isCalloutOpen: prevState.isCalloutOpen && loggedIn,
													};
												},
												() => {
													this.props.setAuthStatus(this.state.isLoggedIn, user).then(() => {
														resolve();
													});
												}
											);
										});
									}}
								/>
							) : (
								""
							)}
						</div>
						<div id="mSignInWrapper">
							{!this.state.loggedInWithGoogle && !this.state.loggedInWithCustomAccount && !isCustomPanelOpen ? (
								<MicrosoftComponent
									signedIn={this.state.loggedInWithMicrosoft}
									currentUser={this.state.currentUser}
									callback={this.ensureSPUser}
									showError={this.showAuthenticationError}
									setAuthStatus={(loggedIn: boolean, user: IAuthenticatedUser) => {
										//console.log("%cMicrosoftLogin: " + loggedIn, "color:purple;font-size:14px;");
										return new Promise((resolve, reject) => {
											this.setState(
												(prevState: ILoginComponentState, props: ILoginComponentProps) => {
													let isLoggedIn = prevState.loggedInWithCustomAccount || prevState.loggedInWithGoogle || loggedIn;
													return {
														loggedInWithMicrosoft: loggedIn,
														loggedInWithCustomAccount: false,
														loggedInWithGoogle: false,
														isLoggedIn: isLoggedIn,
														currentUser: user,
														isCalloutOpen: prevState.isCalloutOpen && loggedIn,
													};
												},
												() => {
													this.props.setAuthStatus(this.state.isLoggedIn, user).then(() => {
														resolve();
													});
												}
											);
										});
									}}
								/>
							) : (
								""
							)}
						</div>
						<div id="cSignInWrapper" style={{ marginTop: "-5px" }}>
							{!this.state.loggedInWithGoogle && !this.state.loggedInWithMicrosoft ? (
								<CustomAuthComponent
									key={`${this.state.isLoggedIn}`}
									currentUser={this.state.currentUser}
									dataProvider={this.dataProvider}
									setAuthStatus={(loggedIn: boolean, user: IAuthenticatedUser) => {
										return new Promise((resolve, reject) => {
											console.log("CustomLogin: " + loggedIn);
											this.setState(
												(prevState) => {
													let isLoggedIn = loggedIn || prevState.loggedInWithGoogle || prevState.loggedInWithMicrosoft;
													return {
														loggedInWithCustomAccount: loggedIn,
														isLoggedIn: isLoggedIn,
														currentUser: user,
														isCalloutOpen: prevState.isCalloutOpen && loggedIn,
													};
												},
												() => {
													this.props.setAuthStatus(this.state.isLoggedIn, user);
													resolve();
												}
											);
										});
									}}
									onPanelStatusChange={(isOpen: boolean) => {
										this.setState({ isCustomPanelOpen: isOpen });
									}}
								/>
							) : (
								""
							)}
						</div>
					</div>
				)}
				{(this.state.loggedInWithCustomAccount || this.state.loggedInWithGoogle || this.state.loggedInWithMicrosoft) && (
					<div style={{ padding: "10px", position: "fixed", top: "64px", right: "10px" }}>
						<Icon
							id="idPersonIcon"
							styles={{ root: { cursor: "pointer", boxShadow: "3px 3px 8px 0px #0000004d" } }}
							onClick={() => {
								this.setState((state) => {
									return { isCalloutOpen: !this.state.isCalloutOpen };
								});
							}}
							componentRef={this.refPersonIcon}
							imageProps={{
								src: "data:image/png;base64,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",
								style: { width: "50px" },
							}}
						/>
						{this.state.isCalloutOpen && (
							<Callout
								target={`#idPersonIcon`}
								styles={{ root: { padding: "10px" } }}
								onDismiss={() => {
									this.setState({ isCalloutOpen: false });
								}}
							>
								<div id="gSignInWrapper">
									{!loggedInWithMicrosoft && !loggedInWithCustomAccount ? (
										<GoogleLoginComponent
											showError={this.showAuthenticationError}
											currentUser={this.state.currentUser}
											callback={this.ensureSPUser}
											setAuthStatus={(loggedIn: boolean, user: IAuthenticatedUser) => {
												return new Promise((resolve, reject) => {
													//console.log("GoogleLogin: " + loggedIn);
													this.setState((prevState) => {
														//let isLoggedIn = prevState.loggedInWithCustomAccount || prevState.loggedInWithGoogle || prevState.loggedInWithMicrosoft;
														let isLoggedIn = loggedIn;
														return {
															loggedInWithGoogle: loggedIn,
															isLoggedIn: isLoggedIn,
															currentUser: user,
															isCalloutOpen: prevState.isCalloutOpen && loggedIn,
														};
													});
													this.props.setAuthStatus(loggedIn, user);
													resolve();
												});
											}}
										/>
									) : (
										""
									)}
								</div>
								<div id="mSignInWrapper">
									{!loggedInWithGoogle && !loggedInWithCustomAccount ? (
										<MicrosoftComponent
											showError={this.showAuthenticationError}
											signedIn={this.state.loggedInWithMicrosoft}
											currentUser={this.state.currentUser}
											callback={this.ensureSPUser}
											setAuthStatus={(loggedIn: boolean, user: IAuthenticatedUser) => {
												return new Promise((resolve, reject) => {
													this.setState((prevState) => {
														//let isLoggedIn = prevState.loggedInWithCustomAccount || prevState.loggedInWithGoogle || prevState.loggedInWithMicrosoft;
														let isLoggedIn = loggedIn;
														return {
															loggedInWithMicrosoft: loggedIn,
															isLoggedIn: isLoggedIn,
															currentUser: user,
															isCalloutOpen: prevState.isCalloutOpen && loggedIn,
														};
													});
													this.props.setAuthStatus(loggedIn, user);
													resolve();
												});
											}}
										/>
									) : (
										""
									)}
								</div>
								<div id="cSignInWrapper">
									{!loggedInWithGoogle && !loggedInWithMicrosoft ? (
										<CustomAuthComponent
											key={`${this.state.isLoggedIn}`}
											currentUser={this.state.currentUser}
											dataProvider={this.dataProvider}
											setAuthStatus={(loggedIn: boolean, user: IAuthenticatedUser) => {
												return new Promise((resolve, reject) => {
													console.log("CustomLogin: " + loggedIn);
													this.setState((prevState) => {
														let isLoggedIn = loggedIn || prevState.loggedInWithGoogle || prevState.loggedInWithMicrosoft;
														return {
															loggedInWithCustomAccount: loggedIn,
															loggedInWithGoogle: false,
															loggedInWithMicrosoft: false,
															isLoggedIn: isLoggedIn,
															currentUser: user,
															isCalloutOpen: prevState.isCalloutOpen && loggedIn,
														};
													});
													this.props.setAuthStatus(this.state.isLoggedIn, user);
													resolve();
												});
											}}
										/>
									) : (
										""
									)}
								</div>
							</Callout>
						)}
					</div>
				)}
				<Dialog
					isOpen={this.state.isErrorOpen}
					dialogContentProps={{
						type: DialogType.normal,
						onDismiss: () => {
							this.setState({ isErrorOpen: false });
						},
					}}
					modalProps={{ isBlocking: true, className: "busyOverlay" }}
				>
					Authentication with {this.state.error_provider} was not possible. The Token provided by {this.state.error_provider} was invalid.
				</Dialog>
			</div>
		);
	}
}

export interface IBaseUserAccount {
	id?: number;
	firstName: string;
	lastName: string;
	email: string;
	accountType: string;
	userId: string;
	isNewUser?: boolean;
}

export interface IUserAccount extends IBaseUserAccount {
	password?: string;
	activateGuid?: string;
}

export interface IAuthenticatedUser extends IBaseUserAccount {
	bearerToken: ITokenInformation;
}

export interface ITokenInformation {
	token: string;
	expirationUTC: Date;
}
